import { render, staticRenderFns } from "./DashboardTermsModal.vue?vue&type=template&id=e5a4cee6&scoped=true&"
import script from "./DashboardTermsModal.vue?vue&type=script&lang=js&"
export * from "./DashboardTermsModal.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTermsModal.vue?vue&type=style&index=0&id=e5a4cee6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a4cee6",
  null
  
)

export default component.exports